import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import $ from "jquery";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QRCodeSVG } from 'qrcode.react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import DatePicker, { DateObject } from "react-multi-date-picker";

const Payment = ({ show, onClose, order }) => {
    const tableRef = useRef(null);
    const qrContainerRef = useRef(null);
    const navigate = useNavigate();
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;

    const [cateringType, setCateringType] = useState([]);
    const [functionType, setFunctionType] = useState([]);
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const [orders, setOrders] = useState([]);
    const [gst_percentage, setGstPercentage] = useState(0);

    const [sendVia, setSendVia] = useState('');
    const [collectedAmount, setCollectedAmount] = useState('');
    const [collectedDate, setCollectedDate] = useState(null);

    // Prepare QR code data
    const urldata = { order_id: order.payment_id, amount: order.amount };
    const encoded = btoa(JSON.stringify(urldata));

    // Fetch GST
    const getGST = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/generalSetting/1`);
            const gst = response.data?.data?.gst ?? 5;
            setGstPercentage(parseFloat(gst));
        } catch (error) {
            console.error("Failed to fetch GST:", error);
            setGstPercentage(5);
        }
    };

    // Fetch Orders
    const fetchOrders = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_order/list`);
            setOrders(Array.isArray(response.data) ? response.data : []);
        } catch {
            toast.error('Failed to fetch orders');
        }
    };

    // Fetch dropdown data
    const fetchCateringType = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
            if (Array.isArray(response.data)) {
                setCateringType(response.data.map(item => ({
                    value: String(item.sno),
                    label: item.catering_type
                })));
            }
        } catch (error) { console.error(error); setCateringType([]); }
    };

    const fetchFunctionType = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
            if (Array.isArray(response.data)) {
                setFunctionType(response.data.map(item => ({
                    value: String(item.sno),
                    label: item.function_type
                })));
            }
        } catch (error) { console.error(error); setFunctionType([]); }
    };

    const fetchMealsPeriod = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);
            const list = response.data?.data;
            if (Array.isArray(list)) {
                setMealsPeriod(list.map(item => ({
                    value: String(item.sno),
                    label: item.itemschedule_name
                })));
            }
        } catch (error) { console.error(error); setMealsPeriod([]); }
    };

    useEffect(() => {
        fetchOrders();
        getGST();
        fetchCateringType();
        fetchFunctionType();
        fetchMealsPeriod();
    }, []);

    const getLabel = (list, sno) => {
        const found = list.find(item => item.value === String(sno));
        return found?.label || '';
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    // Send Online Payment
       const sendPayment = async (order_id) => {
            try {
                // Get the rendered SVG element inside the container
                const svgElement = qrContainerRef.current?.querySelector("svg");

                if (!svgElement) {
                    console.error("SVG element not found!");
                    toast.error("QR Code not generated yet.");
                    return;
                }

                // Serialize SVG to string and encode to Base64
                const svgString = new XMLSerializer().serializeToString(svgElement);
                const base64Svg = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svgString)))}`;

                // Send the data to the backend
                const response = await axios.put(`${BaseUrl}/manage_order/update_order_status/${order_id}/5/2`, {
                    qr_code_image: base64Svg,
                });

                if (response.data?.success) {
                    toast.success("Payment Link Sent & QR Code Saved Successfully");
                    onClose();
                    navigate('/catering-payment');
                } else {
                    toast.error("Failed to update order with QR Code");
                }
            } catch (error) {
                console.error("Failed to send payment link and save QR code:", error);
                toast.error("Failed to send payment link or save QR code");
            }
        };

    // Handle Offline Payment
    const handleOfflinePayment = async () => {
        if (!collectedAmount) return toast.error("Please enter collected amount");
        if (!collectedDate) return toast.error("Please select collected date");

        const finalDate = collectedDate instanceof DateObject
            ? collectedDate.format("YYYY-MM-DD")
            : new DateObject(collectedDate).format("YYYY-MM-DD");

        try {
            const response = await axios.post(`${BaseUrl}/manage_order/handle_verify`, {
                order: order,
                payment: { payment_id: order.payment_id, amount: collectedAmount },
                date: finalDate
            });

            if (response.data?.success) {
                toast.success(response.data.message || "Payment verified successfully!");
                if (onClose) onClose();
            } else {
                toast.error(response.data.message || "Verification failed");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "An error occurred");
        }
    };

    return (
        <Modal show={show} size="lg">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Payment</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>      
                </div>
                <div className="modal-body">
                    <div className="row mb-4">
                        <div className='col-lg-4 mb-2'>
                            <label className='text-black fs-7'>Order Id</label>
                            <div><label className='text-danger fs-6'>{order.orders[0].catering_id}</label></div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <label className='text-black fs-7'>Customer Name</label>
                            <div><label className='text-danger fs-6'>{order.customer.customer_name}</label></div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <label className='text-black fs-7'>Customer Mobile No</label>
                            <div><label className='text-danger fs-6'>{order.customer.customer_number}</label></div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <label className='text-black fs-7'>Catering Type</label>
                            <div><label className='text-danger fs-6'>{getLabel(cateringType, order.orders[0].catering_type)}</label></div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <label className='text-black fs-7'>Function Type</label>
                            <div><label className='text-danger fs-6'>{getLabel(functionType, order.orders[0].function_type)}</label></div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <label className='text-black fs-7'>Total Cost</label>
                            <div><label className='text-danger fs-6'>₹ {order.total_amount}</label></div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <label className='text-black fs-7'>Meals Period</label>
                            <div><label className='text-danger fs-6'>{getLabel(mealsPeriod, order.orders[0].meals_period)}</label></div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <label className='text-black fs-7'>Head Count</label>
                            <div><label className='text-white bg-primary px-2 rounded fs-6'>{order.orders[0].head_count}</label></div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <label className='text-black fs-7'>Order Date</label>
                            <div><label className='text-danger fs-6'>{formatDate(order.orders[0].order_date)}</label></div>
                        </div>
                    </div>

                    {/* Payment Section */}
                    <div className="row mb-3">
                        <div className='col-lg-12'>
                            <div className='text-center mb-4'>
                                <div className="bg-danger-light border-bottom fs-3">
                                    <label className='mb-0'>Payments Details</label>
                                </div>
                            </div>
   
                            <div className="col-lg-12 mb-4">
                                <label className="fs-5">Send Via Whatsapp <span className="required">*</span></label> 
                                <div className="mt-2 d-flex gap-4">
                                    <div className="form-check-inline">
                                        <input type="radio" className="form-check-input" name="send_via" value="online" checked={sendVia === 'online'} onChange={(e) => setSendVia(e.target.value)} />
                                        <label className="form-check-label fs-7">Online</label>
                                    </div>
                                    <div className="form-check-inline">
                                        <input type="radio" className="form-check-input" name="send_via" value="offline" checked={sendVia === 'offline'} onChange={(e) => setSendVia(e.target.value)} />
                                        <label className="form-check-label fs-7">Offline</label>
                                    </div>
                                </div>
                            </div>

                            {sendVia === "online" && (
                                <div className="text-center">
                                    <Link  to={`/online-payment?data=${encodeURIComponent(encoded)}`} target="_blank" className="btn btn-success mb-3">Open Payment Link</Link>
                                    <div ref={qrContainerRef}>
                                        <QRCodeSVG
                                            value={`${window.location.origin}/online-payment?data=${encodeURIComponent(encoded)}`}
                                            size={200}
                                            bgColor="#ffffff"
                                            fgColor="#000000"
                                            level="H"
                                            includeMargin={true}
                                        />
                                    </div>
                                </div>
                            )} 

                            {sendVia === "offline" && (
                                <div className="row">
                                    <div className="col-lg-12 mb-3">
                                        <label>Collected Amount <span className="required">*</span></label>
                                        <input type="text" className="form-control" placeholder="Enter Collected Amount" value={collectedAmount} onChange={(e) => setCollectedAmount(e.target.value)} />
                                    </div>
                                    {/* <div className="col-lg-12 mb-3">
                                        <label>Collected Date <span className="required">*</span></label>
                                        <DatePicker value={collectedDate} onChange={setCollectedDate} format="DD-MM-YYYY" />
                                    </div> */}
                                    <div className="col-lg-12 mb-3">
                                        <label>Collected Date <span className="required">*</span></label>
                                        <div className="datepicker-wrapper" style={{
                                            border: "1px solid #ced4da",
                                            borderRadius: "4px",
                                            padding: "5px"
                                        }}>
                                            <DatePicker
                                            value={collectedDate}
                                            onChange={setCollectedDate}
                                            format="DD-MM-YYYY"
                                            style={{ border: "none", width: "100%" }}
                                            />
                                        </div>
                                        </div>

                                </div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end gap-3 mt-4">
                        <Button className="btn btn-primary" onClick={() => sendVia === 'online' ? sendPayment(order.id) : handleOfflinePayment()}>
                            Send Payment <i className="fas fa-angle-double-right ms-2"></i>
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Payment;
